"use client";
import {
  CarSvgIcon,
  DocumentSvgIcon,
  HomeSvgIcon,
  LightbulbSvgIcon,
  SettingSvgIcon,
  TruckSvgIcon,
  UserSvgIcon,
} from "@/Assets/icons";
import { Menu } from "antd";
import Link from "next/link";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useMemo } from "react";
import styles from "./style.module.scss";
import { useRetrieveTitle } from "@/Utils/helpers";

const Sidenav = () => {
  const { getTitle, direction, language } = useRetrieveTitle();
  const router = useRouter();
  const tab = useSearchParams().get("tab");
  const currentPath = usePathname();
  const navItemsData = [
    {
      key: "dashboard",
      icon: <HomeSvgIcon height="15px" width="15px" className={styles.icon} />,
      href: "/?tab=map_view",
      label: getTitle("dashboard"),
    },
    {
      key: "capabilities",
      icon: (
        <LightbulbSvgIcon height="15px" width="15px" className={styles.icon} />
      ),
      href: "/capabilities",
      label: getTitle("capabilities"),
    },
    {
      key: "services",
      icon: <CarSvgIcon height="15px" width="15px" className={styles.icon} />,
      href: "/services",
      label: getTitle("services"),
    },
    {
      key: "fleets",
      icon: <UserSvgIcon height="15px" width="15px" className={styles.icon} />,
      href: "/fleets",
      label: getTitle("fleets"),
    },
    {
      key: "dispatch",
      icon: <TruckSvgIcon height="15px" width="15px" className={styles.icon} />,
      href: "/dispatch",
      label: getTitle("dispatch"),
    },
    {
      key: "history",
      icon: (
        <DocumentSvgIcon height="15px" width="15px" className={styles.icon} />
      ),
      href: "/history",
      label: getTitle("dispatch_history"),
    },
    {
      key: "jobs",
      icon: (
        <DocumentSvgIcon height="15px" width="15px" className={styles.icon} />
      ),
      href: "/jobs",
      label: getTitle("available_jobs")
    },
    // {
    //   key: "testing",
    //   icon: (
    //     <AlgorithmSvgIcon height="15px" width="15px" className={styles.icon} />
    //   ),
    //   href: "/testing-tool",
    //   label: dictionary?.testing_tool,
    // },
    {
      key: "setting",
      icon: (
        <SettingSvgIcon height="15px" width="15px" className={styles.icon} />
      ),
      href: "/settings",
      label: getTitle("setting"),
    },
  ];

  const navItems = useMemo(() => {
    return navItemsData.map(({ key, href, label, icon }) => ({
      key,
      icon: (
        <div
          className={`${styles.navIcon} ${`${currentPath}${tab ? `?tab=${tab}` : ""}`.includes(href)
            ? styles.active
            : ""
            }`}
        >
          {icon}
        </div>
      ),
      label: (
        <Link
          href={href}
          prefetch={true}
          as={href}
          onClick={(e) => {
            e.preventDefault();
            router.push(href);
          }}
        >
          {label}
        </Link>
      ),
    }));
  }, [currentPath, language]);

  const defaultSelectedKey =
    navItems.find((item) => currentPath.includes(item.key))?.key || "dashboard";

  return (
    <div dir={direction}>
      <Menu
        key={defaultSelectedKey || language}
        theme="light"
        mode="inline"
        defaultSelectedKeys={[defaultSelectedKey]}
        items={navItems}
      />
    </div>
  );
};

export default Sidenav;
